import React from 'react';
import ReactDOM from 'react-dom';
import PerformanceSummaryReact from './PerformanceSummary';

class PerformanceSummary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;
    ReactDOM.render(
      React.createElement(PerformanceSummaryReact, {
        controllerName: this.getAttribute('controller_name'),
      }),
      this.querySelector('#root')
    );
  }
}

customElements.define('performance-summary', PerformanceSummary);
